exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".body[data-v-31ec00ff]{background:#241f16}.session-one-wrap[data-v-31ec00ff]{height:98.56px;height:6.16rem}.session-second-wrap[data-v-31ec00ff]{padding-top:5.12px;padding-top:.32rem}.has-margin-bottom[data-v-31ec00ff]{margin-bottom:21.333px;margin-bottom:1.33333rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/data/efun/gw-template-pre/client/smsgz/assets","/static":"/data/efun/gw-template-pre/client/smsgz/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31ec00ff","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./client/smsgz/pages/hero.vue
// module id = ysXi
// module chunks = 2